import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

/**
 * "We could not confirm your role", said where write affordances have been
 * hidden because of it.
 *
 * `orgRole` being absent is not the same claim as `orgRole` being `viewer`, and
 * the difference is reachable rather than theoretical: `AuthContext.fetchUser`
 * returns a user object with **no `orgRole` key at all** when the context call
 * answers with an access refusal (`AuthContext.tsx`). A context call that fails
 * outright no longer does — it throws and the provider retries — but a backend
 * that predates the field reads the same way. Collapsing that into "you are not
 * permitted" tells them something false about their own account, silently.
 *
 * The surfaces this appears on hide their affordances rather than disabling
 * them, so there is no disabled control left to carry the explanation; the
 * notice is the only thing that can. Pages that *disable* instead (the company
 * settings tab) say it on the control and do not need this.
 *
 * Renders nothing in the two cases that are not this one: while auth is still
 * loading (no claim to make yet), and once the role is known (whatever it says).
 *
 * The string lives under `common`, not `companies`: this appears on workspace
 * screens too, and a key in the companies namespace would send the next
 * translator to edit text they cannot see from there.
 */
export function RoleUnknownNotice() {
  const { t } = useTranslation('dashboard');
  const { user, isLoading } = useAuth();

  if (isLoading || user?.orgRole !== undefined) return null;

  return (
    <p className="text-sm text-gray-500 dark:text-gray-400">
      {t('common.roleUnknownActionsHidden')}
    </p>
  );
}
